
export class IdStateModel {
    idImage: string;
    idFile: File;
    // isStateless: boolean;
    isLoaded: boolean;
    isLoading: boolean;
    isError: boolean;
    isImageLoading: boolean;
    timeOut: boolean;
    errorType: ErrorType;
}
export enum ErrorType {
    TOO_MANY_FACES = 417,
    FACE_NOT_DETECTED = 422,
    UNSUFFICIANT_QUALITY = 200,
    INVALID_MEDIA_TYPE = 415
}
